var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMenu1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 11H2C1.45 11 1 11.45 1 12V18C1 18.55 1.45 19 2 19H18C18.55 19 19 18.55 19 18V12C19 11.45 18.55 11 18 11ZM5 17C3.9 17 3 16.1 3 15C3 13.9 3.9 13 5 13C6.1 13 7 13.9 7 15C7 16.1 6.1 17 5 17ZM18 1H2C1.45 1 1 1.45 1 2V8C1 8.55 1.45 9 2 9H18C18.55 9 19 8.55 19 8V2C19 1.45 18.55 1 18 1ZM5 7C3.9 7 3 6.1 3 5C3 3.9 3.9 3 5 3C6.1 3 7 3.9 7 5C7 6.1 6.1 7 5 7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenu1);
export default __webpack_public_path__ + "static/media/icon_menu_1.52e716d79f9b5d62c570d51317b62e31.svg";
export { ForwardRef as ReactComponent };